import axios from "axios";
import React, { useState,useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import { handle401 } from "../../../utils/handleAuthError";
import Swal from "sweetalert2";

const BASE_URL = "https://dev.sutmmg.codydeasoftech.in/api";

const ReceiveOtherWorks = () => {
  const [loading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [receiveList, setReceiveList] = useState([]);
  const [listLoading, setListLoading] = useState(false);
  const [jobWorkTypes, setJobWorkTypes] = useState([]);
const [selectedJobWorkType, setSelectedJobWorkType] = useState("");
const [submitLoading, setSubmitLoading] = useState(false);

const [page, setPage] = useState(1);
const [isEditMode, setIsEditMode] = useState(false);
const [editId, setEditId] = useState(null);
const [editRow, setEditRow] = useState(null);

const [vendorList, setVendorList] = useState([]);
const [filters, setFilters] = useState({
  vendor_type_id: "",
  vendor_id: "",
});
const [vendorTypeList, setVendorTypeList] = useState([]);
const [modalTableData, setModalTableData] = useState([]);
const [modalLoading, setModalLoading] = useState(false);
const [receiveQtyMap, setReceiveQtyMap] = useState({});
const [selectedRows, setSelectedRows] = useState([]);
  const [perPage, setPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
const [selectedVendorType, setSelectedVendorType] = useState("");
  const today = new Date().toISOString().split("T")[0]; // "YY

  const [formData, setFormData] = useState({
    issue_date: today,
    issue_to: "",
    vendor: "",
    job_work_type: ""
  });


  const fetchReceiveOtherJobList = async (
  pageNo = page,
  filterData = filters,
  perPageCount = perPage
) => {
  try {
    setListLoading(true);

const token = localStorage.getItem("token");

    const payload = {
      receive_from_date: filterData.receive_from_date || "",
      receive_to_date: filterData.receive_to_date || "",
      vendor_type: filterData.vendor_type_id || "",
      vendor: filterData.vendor_id || "",
      page: String(pageNo),
      per_page: String(perPageCount),
    };

    const res = await axios.post(
      `${BASE_URL}/getOthersRececeivedItemsList`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data?.status === true) {

  setReceiveList(res.data.data || []);

  setTotalRecords(res.data.total_records || 0);
  setTotalPages(
    Math.ceil(
      (res.data.total_records || 0) / perPageCount
    )
  );
  setPage(Number(res.data.page || pageNo));

} else {
  setReceiveList([]);
}


  } catch (error) {
    console.error(error);
    if (handle401(error)) return;
    setReceiveList([]);
  } finally {
    setListLoading(false);
  }
};




  const resetModalState = () => {
  setFormData({

    issue_date: "",
    issue_to: "",
    vendor: "",
    remarks: "",
  });

  setModalTableData([]);
  setSelectedRows([]);
  setReceiveQtyMap({});
  setIsEditMode(false);
  setEditRow(null);
  setEditId(null);
};

const toggleSelectAllRows = (checked) => {
  if (checked) {
    setSelectedRows(modalTableData);
  } else {
    setSelectedRows([]);
    setReceiveQtyMap({});
  }
};


const getPageNumbers = () => {
  const pages = [];
  const maxPagesToShow = 5;

  let start = Math.max(1, page - 2);
  let end = Math.min(totalPages, start + maxPagesToShow - 1);

  if (end - start < maxPagesToShow - 1) {
    start = Math.max(1, end - maxPagesToShow + 1);
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return pages;
};

useEffect(() => {
  fetchReceiveOtherJobList(1, filters, perPage);
}, []);


const fetchJobWorkTypes = async () => {
  try {
const token = localStorage.getItem("token");

    const res = await axios.get(
      `${BASE_URL}/jobWorkTypeList`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data?.status) {
      setJobWorkTypes(res.data.data.jobWorkTypeList || []);
    }
  } catch (error) {
    console.log(error);
  }
};


const fetchReceiveOtherJobItemsForModal = async (vendorTypeId, vendorId) => {
  if (!vendorTypeId || !vendorId) return;

  try {
    setModalLoading(true);
const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/getDataForReceiveOtherJobItems`,
      {
        vendor_type: vendorTypeId,
        vendor: vendorId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data?.status === true) {

      const rows = (res.data.data?.jobs || []).map((job) => {

        const jobNames = (job.jobs || [])
          .map(j => j.action_name)
          .join(", ");

        return {
          id: job.id,                    // one row per job
          issue_date: job.issue_date,
          job_names: jobNames,
job_items: job.job_items || [],
          // if you still want to show item info, take first item only
          item_name: job.job_items?.[0]?.item_name || "-",
          size: job.job_items?.[0]?.size || "-",
          total_quantity: job.job_items?.[0]?.total_quantity || "-",

          date_of_start_returning: job.date_of_start_returning,
        };
      });

      setModalTableData(rows);
      setSelectedRows([]);
      setReceiveQtyMap({});
    } else {
      setModalTableData([]);
    }

  } catch (error) {
    console.error("Other job items fetch failed", error);
    if (handle401(error)) return;
    setModalTableData([]);
  } finally {
    setModalLoading(false);
  }
};


// const handleSubmitReceiveOtherJobItems = async () => {
//   if (!formData.issue_date) {
//     Swal.fire("Error", "Receive date is required", "error");
//     return;
//   }

//   if (modalTableData.length === 0) {
//   Swal.fire("Error", "No jobs available to receive", "error");
//   return;
// }

// const jobIds = modalTableData.map(r => r.id);


//   try {
// const token = localStorage.getItem("token");

//     const payload = {
//       receive_date: formData.issue_date,
//       jobIds: jobIds,
//       remarks: formData.remarks || ""
//     };

//     const res = await axios.post(
//       `${BASE_URL}/receiveOtherJobItems`,
//       payload,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     if (res.data?.status === true) {
//       Swal.fire("Success", res.data.message || "Received successfully", "success");

//       setShowModal(false);
//       resetModalState();
//       fetchReceiveOtherJobList(page, filters, perPage);

//     } else {
//       Swal.fire("Error", res.data?.message || "Something went wrong", "error");
//     }

//   } catch (error) {
//     console.error(error);
//     if (handle401(error)) return;
//     Swal.fire("Error", "Failed to save", "error");
//   }
// };


const handleSubmitReceiveOtherJobItems = async () => {
  if (!formData.issue_date) {
    Swal.fire("Error", "Receive date is required", "error");
    return;
  }

  if (modalTableData.length === 0) {
    Swal.fire("Error", "No jobs available to receive", "error");
    return;
  }

  const jobIds = modalTableData.map((r) => r.id);

  try {
    setSubmitLoading(true); // 🔥 START LOADER

const token = localStorage.getItem("token");

    const payload = {
      receive_date: formData.issue_date,
      jobIds: jobIds,
      remarks: formData.remarks || "",
    };

    const res = await axios.post(
      `${BASE_URL}/receiveOtherJobItems`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data?.status === true) {
      Swal.fire(
        "Success",
        res.data.message || "Received successfully",
        "success"
      );

      setShowModal(false);
      resetModalState();
      fetchReceiveOtherJobList(page, filters, perPage);
    } else {
      Swal.fire(
        "Error",
        res.data?.message || "Something went wrong",
        "error"
      );
    }
  } catch (error) {
    console.error(error);
    if (handle401(error)) return;

    Swal.fire("Error", "Failed to save", "error");
  } finally {
    setSubmitLoading(false); // 🔥 STOP LOADER
  }
};
  const fetchVendorTypes = async () => {
  try {
const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/vendorTypesList`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data?.status === true) {
      setVendorTypeList(res.data.data || []);
    } else {
      setVendorTypeList([]);
    }
  } catch (error) {
    console.error("Vendor type fetch failed", error);
        if (handle401(error)) return;

    setVendorTypeList([]);
  }
};

const fetchVendorsByType = async (vendorTypeId) => {
  if (!vendorTypeId) {
    setVendorList([]);
    return;
  }

  try {
const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/vendorsList`,
      { vendor_type_id: vendorTypeId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data?.status === true) {
      setVendorList(res.data.data || []);
    } else {
      setVendorList([]);
    }
  } catch (error) {
    console.error("Vendor fetch failed", error);
        if (handle401(error)) return;

    setVendorList([]);
  }
};

 // useEffect(() => { fetchReceiveCutpieceList(1); }, [perPage]);

const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);
  if (isNaN(d)) return "-";

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}-${month}-${year}`; // DD/MM/YYYY
};



  const openAddModal = () => {
    setIsEditMode(false);
    setFormData({
      fabric_type: "",
      quantity: "",
      issue_date: today,
      issue_to: "",
      vendor: ""
    });
    setShowModal(true);
  };



  useEffect(() => {
    fetchVendorTypes();
    fetchJobWorkTypes();
  }, []);


  useEffect(() => {
//   fetchReceiveCutpieceList(1, { vendor_type_id: "", vendor_id: "" }, perPage);
}, []);


  const theadStyle ={

                  padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center",

  }

  return (
    <div className="container mt-4" style={{ maxWidth: 1559 }}>
      {/* HEADER */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div className="px-4 py-3 text-white" style={{ background: "#1565C1" }}>
          <h5 className="mb-0 fw-bold">
            <i className="fa-solid fa-scissors"></i> Receive
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            <Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-dark">Organisation Type</Form.Label>
    <Form.Select
      value={selectedVendorType}
      onChange={(e) => {
        const vendorTypeId = e.target.value;

        // Update selected vendor type
        setSelectedVendorType(vendorTypeId);

        // Reset vendor selection
        setFormData({ ...formData, vendor_id: "" });

        // Update filters for table/search
const newFilters = {
  vendor_type_id: vendorTypeId,
  vendor_id: "",
};

setFilters(newFilters);
// fetchReceiveCutpieceList(1, newFilters, perPage);

        // Fetch vendors for selected type
        if (vendorTypeId) {
          fetchVendorsByType(vendorTypeId);
        } else {
          setVendorList([]);
        }

      }}
      style={{
        borderRadius: "10px",
        border: "2px solid #1565C1",
      }}
    >
      <option value="">Select Organisation Type</option>
      {vendorTypeList.map((v) => (
        <option key={v.id} value={v.id}>
          {v.vendor_type_name} ({v.vendor_type_short_name})
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>

<Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-dark">Organisation</Form.Label>
    <Form.Select
       value={filters.vendor_id || ""}
  onChange={(e) => {
    const vendorId = e.target.value;

    const newFilters = {
      ...filters,
      vendor_id: vendorId,
    };

    setFilters(newFilters);
    // fetchReceiveCutpieceList(1, newFilters, perPage);
  }}
      style={{
        borderRadius: "10px",
        border: "2px solid #1565C1",
      }}
      disabled={!selectedVendorType || vendorList.length === 0}
    >
      <option value="">Select Organisation</option>
      {vendorList.map((v) => (
        <option key={v.id} value={v.id}>
          {v.vendors_master_name}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>

            <Col md={3}>
                                                  <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold text-dark">Record Showing</Form.Label>

                            <Form.Select
                             style={{
                                            borderRadius: "10px",
                                            border: "2px solid #1565C1",
                                          }}
                              value={perPage}
  onChange={(e) => {
    const value = Number(e.target.value);
    setPerPage(value);
    setPage(1);

    // 🔥 reload list with current filters
  }}

                            >
                              <option value={10}>10 Per Page</option>
                                          <option value={25}>25 Per Page</option>
                                          <option value={50}>50 Per Page</option>
                                          <option value={100}>100 Per Page</option>
                            </Form.Select>
                            </Form.Group>
                          </Col>
            <Col md={4} className="d-flex gap-3 mt-3">
                                                        {/* SEARCH */}
                                                        <Button
                                                          className="w-50 fw-semibold text-white"
                                                          style={{
                                                            background: "#1565C1",
                                                            border: "none",
                                                            borderRadius: "10px",
                                                            transition: "0.3s",
                                                          }}
                                                          onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                                                          onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
onClick={() => {
    fetchReceiveOtherJobList(1, filters, perPage);
  }}
                                                        >
                                                          <i className="fa-solid fa-magnifying-glass me-2"></i> Search
                                                        </Button>

                                                        {/* RESET */}
                                                        <Button
                                                          className="w-50 fw-semibold text-white"
                                                          style={{
                                                            background: "#E53935",
                                                            border: "none",
                                                            borderRadius: "10px",
                                                            transition: "0.3s",
                                                          }}
                                                          onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
                                                          onMouseLeave={(e) => (e.target.style.background = "#E53935")}
                                                          onClick={() => {
  const clearedFilters = {
    vendor_type_id: "",
    vendor_id: "",
  };

  setFilters(clearedFilters);
  setSelectedVendorType("");
  setVendorList([]);
  setFormData({ ...formData, vendor_id: "", issue_to: "" });
  setPerPage(10);
  setPage(1);
fetchReceiveOtherJobList(1, clearedFilters, 10);
}}



                                                        >
                                                          <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
                                                        </Button>
                                                      </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ADD BUTTON */}
      <Button
        className="mb-3 text-white"
        style={{
          background: "linear-gradient(135deg, #2E7D32, #66BB6A)",
          borderRadius: "10px",
        }}

        onClick={openAddModal}
      >
        <i className="fa-solid fa-circle-plus me-2"></i> Receive Stitching and Other Job Items
      </Button>

      {/* TABLE */}
      {!loading && (
        <Card className="border-0">
          <Table hover responsive striped>
            <thead>
              <tr className="text-center">
                <th style={theadStyle}>SL</th>
        <th style={theadStyle}>Receive Date</th>
        <th style={theadStyle}>Issue Type</th>
        <th style={theadStyle}>Organisation</th>
                <th style={theadStyle}>Jobs</th>

        <th style={theadStyle}>Item</th>
        <th style={theadStyle}>Return Date</th>
                <th style={theadStyle}>Remarks</th>




              </tr>
            </thead>
            <tbody>
               {receiveList.length > 0 ? (
        receiveList.map((row, index) => (
        //   <tr key={row.id} className="text-center">
        //     <td>{(page - 1) * perPage + index + 1}</td>
        //     <td>{formatDate(row.receive_date)}</td>
        //     {/* <td>{row.vendor_type_short_name}</td> */}
        //     <td>{row.vendors_master_name} ({row.vendor_type_short_name})</td>
        //     <td>{row.item_name}</td>
        //     <td>{row.size}</td>
        //     <td>{row.total_quantity}</td>
        //     <td className="text-success fw-bold" >
        //       {row.receive_quantity}
        //     </td>
        //     <td className="text-danger fw-bold">
        //       {row.pending_quantity}
        //     </td>
        //     <td>{row.fabric_requirement}</td>
        //     <td>{formatDate(row.date_of_start_returning)}</td>

        //   </tr>

        <tr key={row.id} className="text-center">

  <td>{(page - 1) * perPage + index + 1}</td>
  <td>{formatDate(row.returned_on)}</td>
  <td>{formatDate(row.issue_date)}</td>

  <td>
    {row.vendors_master_name} ({row.vendor_type_short_name})
  </td>
<td>
  {(row.jobs || []).map((j, i) => (
    <div key={i}>{j.action_name}</div>
  ))}
</td>

  {/* Item */}
  <td>
    {(row.job_items || []).map((it, i) => (
      <div key={i}>{it.item_name} ({it.size}) x {it.total_quantity}</div>
    ))}
  </td>




  <td>{formatDate(row.date_of_start_returning)}</td>
    <td>{row.returned_remarks}</td>


</tr>

        ))
      ) : (
        <tr>
          <td colSpan="11" className="text-center">
            No Data Found
          </td>
        </tr>
      )}
            </tbody>
          </Table>
{totalPages > 1 && (
  <div className="d-flex justify-content-center mt-4">
    <nav>
      <ul className="pagination shadow-sm">

        {/* First */}
        <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => fetchReceiveOtherJobList(1, filters, perPage)}
            disabled={page === 1}
          >
            «
          </button>
        </li>

        {/* Prev */}
        <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() =>
              fetchReceiveOtherJobList(page - 1, filters, perPage)
            }
            disabled={page === 1}
          >
            ‹
          </button>
        </li>

        {/* Page Numbers */}
        {getPageNumbers().map((p) => (
          <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
            <button
              className="page-link"
              onClick={() =>
                fetchReceiveOtherJobList(p, filters, perPage)
              }
            >
              {p}
            </button>
          </li>
        ))}

        {/* Next */}
        <li
          className={`page-item ${
            page === totalPages ? "disabled" : ""
          }`}
        >
          <button
            className="page-link"
            onClick={() =>
              fetchReceiveOtherJobList(page + 1, filters, perPage)
            }
            disabled={page === totalPages}
          >
            ›
          </button>
        </li>

        {/* Last */}
        <li
          className={`page-item ${
            page === totalPages ? "disabled" : ""
          }`}
        >
          <button
            className="page-link"
            onClick={() =>
              fetchReceiveOtherJobList(totalPages, filters, perPage)
            }
            disabled={page === totalPages}
          >
            »
          </button>
        </li>

      </ul>
    </nav>
  </div>
)}


        </Card>
      )}

      {/* MODAL */}
      <Modal show={showModal} onHide={() => {
    setShowModal(false);
    resetModalState();
  }} centered size="xl" backdrop="static"
  keyboard={false}>
        <Modal.Header closeButton style={{ background: "#3399ff", color: "#fff" }}>
          <Modal.Title>
            {isEditMode ? "Edit Receive Stitching and Other Job Items" : "Receive Stitching and Other Job Items"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
           <Row className="mb-2">
            <Col md={6}>

             <Form.Group className="mb-2">
            <Form.Label>Receive Date <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="date"
              value={formData.issue_date}
              onChange={(e) =>
                setFormData({ ...formData, issue_date: e.target.value })
              }
            />
          </Form.Group>
            </Col>


           </Row>



      <Row className="mb-2">
        <Col md={6}>
          <Form.Group className="mb-2">
            <Form.Label>
              Select Organisation Type <span className="text-danger">*</span>
            </Form.Label>

            <Form.Select
              value={formData.issue_to}
  onChange={(e) => {
    const vendorTypeId = e.target.value;

    setFormData({
      ...formData,
      issue_to: vendorTypeId,
      vendor: "",
    });

    setVendorList([]);
    setModalTableData([]);

    if (vendorTypeId) {
      fetchVendorsByType(vendorTypeId);
    }
  }}
            >
              <option value="">Select Organisation Type</option>
              {vendorTypeList.map((v) => (
                <option key={v.id} value={v.id}>
                  {v.vendor_type_name} ({v.vendor_type_short_name})
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-2">
            <Form.Label>
              Select Organisation <span className="text-danger">*</span>
            </Form.Label>

            <Form.Select
value={formData.vendor}
  onChange={(e) => {
    const vendorId = e.target.value;

    setFormData({
      ...formData,
      vendor: vendorId,
    });

    if (formData.issue_to && vendorId) {
      fetchReceiveOtherJobItemsForModal(
        formData.issue_to,
        vendorId
      );
    }
  }}
            >
              <option value="">Select Organisation</option>
              {vendorList.map((v) => (
                <option key={v.id} value={v.id}>
                  {v.vendors_master_name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>







<hr />

<h6 className="fw-bold mb-2">Receive Stitching & Other Job Items</h6>


{modalLoading ? (
  <div className="text-center">Loading...</div>
) : modalTableData.length > 0 ? (
  <>


    <Table bordered hover size="sm">
      <thead>
  <tr className="text-center">


    <th>SL</th>
    <th>Issue Date</th>
    <th>Jobs</th>
    <th>Item</th>
    <th>Return Date</th>
  </tr>
</thead>


      <tbody>
        {modalTableData.map((row, index) => (
          <tr key={row.id} className="text-center">
            {/* ✅ row checkbox */}


            <td>{index + 1}</td>
            <td>{formatDate(row.issue_date)}</td>
            <td>{row.job_names}</td>
             {/* ✅ Item column (loop job_items) */}
      <td className="text-start">
        {row.job_items.map((it, i) => (
          <div key={i}>
            {it.item_name} ({it.size}) x {it.total_quantity}
          </div>
        ))}
      </td>
            <td>{formatDate(row.date_of_start_returning)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </>
) : (
  <div className="text-center text-muted">
    No data found
  </div>
)}







          {/* Beneficiary ID - only for SHG */}
                    {formData.issue_to === "SHG" && (
                      <Form.Group className="mb-2">
                        <Form.Label>Beneficiary ID (Optional)</Form.Label>
                        <Form.Control
                          placeholder="Enter Beneficiary ID"
                          value={formData.beneficiary_id}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              beneficiary_id: e.target.value,
                            })
                          }
                        />
                      </Form.Group>
                    )}



          <Form.Group className="mb-2">
            <Form.Label>Remarks(Optional)</Form.Label>
            <Form.Control
              type="text"
              value={formData.remarks}
              placeholder="remarks"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  remarks: e.target.value,
                })
              }
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => setShowModal(false)} variant="danger">Cancel</Button>
          <Button
  variant="success"
  onClick={handleSubmitReceiveOtherJobItems}
  disabled={submitLoading}
>
  {submitLoading ? (
    <>
      <span className="spinner-border spinner-border-sm me-2"></span>
      Submitting...
    </>
  ) : (
    "Submit"
  )}
</Button>

        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ReceiveOtherWorks;
